import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import HotelSettingsMyotbMyotbBaseController from 'lumen/controllers/hotel/settings/myotb/myotb-base';

export default class HotelSettingsMyotbActiveController extends HotelSettingsMyotbMyotbBaseController {
  @service access;
  @service alerting;
  @service errorTracking;
  @service intl;
  @service myotbSs;
  @service toast;

  @tracked isInterestedInBenchmark = false;

  get isSaveEnabled() {
    return (
      this.isInterestedInBenchmark !==
        this.otbSelfService.wantsToSeeBenchmark ||
      this.myotbSs.showMarketBenchmarkEnabledView
    );
  }

  get saveButtonText() {
    const { wantsToSeeBenchmark } = this.otbSelfService;

    if (!this.access.hasFeature('otb.market_benchmark_eligible')) {
      // If wantsToSeeBenchmark is true, the user has agreed.
      // Or if wantsToSeeBenchmark hasn't been set yet (null), treat it like the user has agreed.
      // Show "Don't notify me" in that case.
      if (wantsToSeeBenchmark || wantsToSeeBenchmark === null) {
        return this.intl.t('settings.my_otb.setup_active.dont_notify_me');
      }

      return this.intl.t('settings.my_otb.setup_active.get_notified');
    }

    // If wantsToSeeBenchmark is true, the user has agreed.
    // Or if wantsToSeeBenchmark hasn't been set yet (null), treat it like the user has agreed.
    // Show "Disable benchmark" in that case.
    if (wantsToSeeBenchmark || wantsToSeeBenchmark === null) {
      return this.intl.t('settings.my_otb.setup_active.disable_benchmark');
    }

    return this.intl.t('settings.my_otb.setup_active.enable_benchmark');
  }

  get showBenchmarkSummary() {
    return (
      this.access.hasFeature('otb.benchmark_question.view') &&
      this.access.hasFeature('otb.selfservice.edit')
    );
  }

  @action
  async onClickNext() {
    if (this.myotbSs.showMarketBenchmarkEnabledView) {
      this.isInterestedInBenchmark = false;
    }

    try {
      this.isLoading = true;
      this.otbSelfService.wantsToSeeBenchmark = this.isInterestedInBenchmark;
      await this.otbSelfService.save();
      this.toast.success(this.intl.t('general.changes_saved').toString(), {
        showIcon: true,
      });
    } catch (error) {
      // If the save() fails: revert the previous state of the otbSelfService object
      this.otbSelfService.rollbackAttributes();
      this.alerting.showErrorAlert();
      this.errorTracking.captureException(error);
    } finally {
      this.isLoading = false;
    }
  }

  @action
  setDefaults() {
    // For subscriptions that already had an OTB integration and didn't answer the benchmark question before, default to true
    this.isInterestedInBenchmark =
      this.otbSelfService.wantsToSeeBenchmark ?? true;
  }

  @action
  toggleBenchmarkInterest(event) {
    this.isInterestedInBenchmark = event.target.checked;
  }
}
